import React from "react";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="fixed flex h-full w-full items-center justify-center bg-gray-400 bg-opacity-40">
      <div className="loader ease-linear h-12 w-12 rounded-full border-4 border-t-4 border-primary" />
    </div>
  );
};

export default LoadingSpinner;
